module.exports = __webpack_public_path__ + "img/k1.73d66c88.png";